var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.00006C2.55228 1.00006 3 1.44777 3 2.00006V13.0001H14C14.5523 13.0001 15 13.4478 15 14.0001C15 14.5523 14.5523 15.0001 14 15.0001H1V2.00006C1 1.44777 1.44772 1.00006 2 1.00006ZM13.1055 1.55282C13.3525 1.05884 13.9531 0.85862 14.4471 1.10561C14.9411 1.3526 15.1413 1.95327 14.8943 2.44725L11.8943 8.44725C11.5258 9.1843 10.474 9.1843 10.1055 8.44725L8.99989 6.2361L6.89432 10.4472C6.64733 10.9412 6.04666 11.1415 5.55268 10.8945C5.0587 10.6475 4.85848 10.0468 5.10547 9.55282L8.10547 3.55282C8.47399 2.81577 9.5258 2.81577 9.89432 3.55282L10.9999 5.76397L13.1055 1.55282Z",
    fill: "#1B3380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.f757358f3cc78c5456a7a8c6452f8026.svg";
export { ForwardRef as ReactComponent };